<script setup>
import adminVideoButton from '@/components/main/adminVideo/button/adminVideoButton.vue';
import getTree from "@/components/main/adminVideo/folder/getTree.vue";
import {computed, onBeforeUnmount, onMounted, ref, shallowRef, toRef, watch} from "vue";
import qs from "qs";
import TotalCount from "@/components/common/totalCount/totalCount.vue";
import DetailVideo from "@/components/modal/video/detailVideo.vue";
import axios from "@/axios";
import adminVideoModal from '@/components/modal/video/adminVideoModal.vue';
import {useComStore, useFolderStore, useLanguageStore, useLoadingStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
import {useToast} from "@/composables/useToast";

const toast = useToast();
import subMenuModal from "@/components/modal/video/subMenuModal.vue";
import FolderModal from "@/components/modal/video/folderModal.vue";
import NameChangeModal from "@/components/modal/video/nameChangeModal.vue";
import MoveModal from "@/components/modal/video/moveModal.vue";
import TransferModal from "@/components/modal/video/transferModal.vue";
import DeleteVideoModal from "@/components/modal/video/deleteVideoModal.vue";

const languageStore = useLanguageStore();
const comStore = useComStore();
const folderStore = useFolderStore();
const loadingStore = useLoadingStore();
const isLoading = toRef(loadingStore.getIsLoading);
const baseUrl = process.env.VUE_APP_API_URL;
const emits = defineEmits(['set_title'])
const isVideoDetail =ref(false);
const loading = ref(false);
const totalCount = ref(0);
const title = computed(() => languageStore.get('videoManagement'));
const videoLists =  ref([])
const currentFolder = ref(folderStore.getMinFolder());
const selectedFolder = ref("");
const selectedItem = ref();
const upperFolder = ref(folderStore.getOneFolder(currentFolder.value)?.upperFolderId ?? null)
// 선택된 여러개
const checkedItems = ref([])
const showInsertModal = ref(false);
const selectedService = ref("");
const childrenFolders = ref([]);
const subModalValue = ref("");
const modalX = ref(0);
const modalY = ref(0);
const subModalType = ref("")
const searchFolder = ref();
const isSubModal = ref(false);
const isFolderModal = ref(false);
const isChangeFolder = ref(false);
const isNameChangeModal = ref(false);
const isMoveModal = ref(false);
const isResizing = ref(false);
const searchValue = ref("");
const searchVideo = ref("");
const isVideoSearching = ref(false);
const isTransferModal  = ref(false);
const isDeleteModal = ref(false);
const selectedVideosForDelete = ref([]);


const set_isTransferModal = (v)=>{
  isTransferModal.value = v;
}
const set_isResizing = (v)=>{
  isResizing.value = v;
}
const set_isMoveModal = (v)=>{
  if(checkedItems.value.length === 0 ){
    toast.warning(languageStore.get('pleaseSelectFile'));
    return;
  }
  isMoveModal.value = v;
}
const set_isNameChangeModal = (v)=>{
  isNameChangeModal.value = v
}
const set_isChangeFolder = (v)=>{
  isChangeFolder.value = v
}
const set_isFolderModal = (v)=>{
 isFolderModal.value = v
}
const set_currentFolder = (folder)=>{
  currentFolder.value = folder;
  childrenFolders.value =folderStore.getChildrenFolder(folder);
  upperFolder.value = folderStore.getOneFolder(folder);
  getVideos();
}
const set_isVideoDetail = (m)=>{
  isVideoDetail.value = m;
}
const set_selectedFolder = (id)=>{
  checkedItems.value = [];
  selectedFolder.value = id;
}
const openDetailModal=(item)=> {
  selectedItem.value = item;
  isVideoDetail.value = true
}
const getVideos = ()=>{
  axios.get('/admin/videoList/'+currentFolder.value , {
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat : 'repeat' })
    }
  }).then(async response => {
    totalCount.value = response.data.length;
    // 각 비디오의 전송 상태 조회
    const videosWithStatus = await Promise.all(
        response.data.map(async (video) => {
          try {
            const statusRes = await axios.get(`/admin/transfer/status/${video.id}`);
            return { ...video, transferStatus: statusRes.data.status };
          } catch (e) {
            return { ...video, transferStatus: 'NONE' };
          }
        })
    );
    videoLists.value = videosWithStatus;
    loading.value = false;
  }).catch(error => {
    console.log(error)
    loading.value = false;
  })
}
const computedList = computed(()=>{
  return isVideoSearching.value ?computedSearch.value : videoLists.value
})
const computedSearch = computed(()=>{
  return videoLists.value.filter(v=>v.videoTitle.includes(searchVideo.value))
})

const toggleItemSelection = (id)=>{
  selectedFolder.value = "";
  let validate = checkedItems.value.includes(id)
  if(validate){
    checkedItems.value = checkedItems.value.filter(v => !v.includes(id));
  }else{
    checkedItems.value.push(id);
  }
}
const deleteSelectedItems = ()=> {
  let isFile = checkedItems.value.length > 0
  let isFolder = selectedFolder.value !== ""

  if(!isFile && !isFolder) return

  if(isFile && !isFolder){
    // 선택된 영상 정보 가져오기
    selectedVideosForDelete.value = checkedItems.value.map(id =>
        videoLists.value.find(v => v.id === id)
    ).filter(Boolean);
    isDeleteModal.value = true;
  }else if(isFolder && !isFile){
    // 폴더 삭제는 기존 로직 유지
    if(confirm(languageStore.get('deleteConfirm'))){
      folderStore.deleteFolder(selectedFolder.value);
      toast.success(languageStore.get('deleteSuccess'));
      reloadFolder(selectedFolder.value);
    }
  }
}

const confirmVideoDelete = (deleteSns) => {
  const data = {
    videoIds: checkedItems.value,
    deleteSns: deleteSns
  };

  loadingStore.set_isLoading(true);
  axios.delete("/admin/video/delete", {
    data: data,
    headers: { 'Content-Type': 'application/json' }
  })
  .then(() => {
    getVideos();
    checkedItems.value = [];
    isDeleteModal.value = false;
    if(deleteSns) {
      toast.success(languageStore.get('deleteWithSnsSuccess'));
    } else {
      toast.success(languageStore.get('deleteSuccess'));
    }
  })
  .catch(e => {
    console.log(e);
    toast.error(languageStore.get('deleteFailed'));
  })
  .finally(() => {
    loadingStore.set_isLoading(false);
  });
}
const openYoutubeVideoLink = (e)=>{
  const url = 'https://youtu.be/'+e;
  window.open(url);
}
const videoDownload = (value)=>{
  let data;
  if(value){
    data= value;
  }else{
    data = checkedItems.value
  }
  if(checkedItems.value.length >1) {
    toast.warning(languageStore.get('canDownloadOnlyOneFile'))
  }else if(checkedItems.value.length === 1){
    location.href=`${baseUrl}/admin/video/download/`+data
  }else{
    toast.warning(languageStore.get('pleaseSelectFile'));
  }
}
const insertModalClose = ()=>{
  getVideos();
  showInsertModal.value = false;
}
const openModal = (service,data)=> {
  selectedService.value = service;
  if(data != null ){
    selectedItem.value = getOneVideo(data).value;
  }
  showInsertModal.value = true;
}
const getOneVideo = (data)=>computed(()=>{
  return videoLists.value.find(f=> data == f.id)
})
const folderIn = (i)=>{
  set_currentFolder(i);
}
const rightSideClickEvent = (event, type, value)=>{
  subModalType.value = type;
  subModalValue.value = value;
  modalX.value = event.pageX;
  modalY.value = event.pageY;
  if(type == 'file'){
    selectedFolder.value="";
    if(checkedItems.value.length > 1 ){
      if(!checkedItems.value.includes(value)){
        checkedItems.value = [value];
      }else{
        subModalType.value ='files'
        subModalValue.value = checkedItems.value
      }
    }else{
      checkedItems.value = [value];
    }
  }else if(type=='folder'){
    set_selectedFolder(value)
    checkedItems.value = [];
  }else{
    selectedFolder.value = "";
    checkedItems.value = [];
  }
  isSubModal.value=true;
}
const closeModal = (e)=>{
  if(isSubModal.value){
    isSubModal.value = false;
  }else{
    return
  }
}
const saveFolder = (folderName)=>{
  let data = {
    'folderName' : folderName ,
    'upperFolderId' : currentFolder.value
  }
  folderStore.saveFolder(data);
  isFolderModal.value = false;

  reloadFolder();
}
const editName = (name)=>{
  const type = subModalType.value
  if(type === 'folder'){
    let data = {
      'folderId' : subModalValue.value,
      'folderName' : name
    }
    folderStore.updateFolder(data)
    reloadFolder();
  }else if( type === 'file'){
    //a
  }else{
    return
  }
}
const moveItems = (v)=>{
  const type= subModalType.value;
  if(type == 'file' || type == 'files') {
    console.log(checkedItems.value)
    const data ={
      'videoId' : checkedItems.value,
      'folderId' : v
    }
    axios.put("/admin/video/folder", data, {headers: { 'Content-Type': 'application/json' }})
        .then(()=>{
          getVideos()
        })
  }else if(type === 'folder'){
    const data ={
      'folderId' : subModalValue.value,
      'upperFolderId' : v
    }
    folderStore.updateFolder(data);
    reloadFolder();
  }else{
    toast.warning(languageStore.get('abnormalAccess'))
  }
}
const reloadFolder = (data)=>{
  // 저장하고 가져와야하는데 인식못해서 setTimeOut
  setTimeout(()=>{

    if(folderStore.isFolder(data)){
      currentFolder.value = folderStore.getMinFolder();
    }
    set_isChangeFolder(true)
    childrenFolders.value = folderStore.getChildrenFolder(currentFolder.value);
  },1000)
}
const fn_search = ()=>{
  searchVideo.value = searchValue.value;
  isVideoSearching.value = true;
  totalCount.value = computedList.value.length;
}
const searchCancel = ()=>{
  totalCount.value= videoLists.value.length;
  searchVideo.value = "";
  searchValue.value ="";
  isVideoSearching.value = false;
}
const showTransferModal = ()=>{
  let isSelectFile = checkedItems.value.length < 1
  let selectFolder = selectedFolder.value !== ""
  if(selectFolder){
    toast.warning(languageStore.get('folderCannotBeTransmitted'));
    return
  }else if (isSelectFile){
    toast.warning(languageStore.get('selectFile'))
    return
  }
  set_isTransferModal(true);
}

const transferVideos = (d)=>{
  loadingStore.set_isLoading(true);
  let data = {"videoIds" : checkedItems.value, ...d }
  axios.post("/admin/video/transfer", data,{headers: { 'Content-Type': 'application/json' }})
      .then(s=>{
        loadingStore.set_isLoading(false);
        if(s.data){
          toast.success(languageStore.get('transmissionComplete'))
        }else{
          toast.error(languageStore.get('transmissionFailed'))
        }
      }).catch(err=> {
        console.log(err)
        loadingStore.set_isLoading(false);
  })
}


// drag & drop
const supportsFileSystemAccessAPI = ref('getAsFileSystemHandle' in DataTransferItem.prototype)
const supportsWebkitGetAsEntry = ref('webkitGetAsEntry' in DataTransferItem.prototype)
const supportsDragAndDropUpload = ref(supportsFileSystemAccessAPI.value || supportsWebkitGetAsEntry.value)

function setupElement(elem, supportsDragAndDropUpload) {
  if (!elem) return;
  elem.addEventListener('dragover', eventPreventDefault)
  elem.addEventListener('dragenter', () => changeElementStyle(elem, supportsDragAndDropUpload ? 'enter' : 'leave'))
  elem.addEventListener('dragleave', (e) => !elem.contains(e.fromElement) && changeElementStyle(elem, 'leave'))
  elem.addEventListener('drop', getDropHandler(elem, supportsDragAndDropUpload))
}


function changeElementStyle(elem, event) {
  if (event === "enter") {
    elem.style.outline = 'solid cornflowerblue 3px'
    elem.style.background = 'aliceblue'
  } else {
    elem.style.outline = ''
    elem.style.background = ''
  }
}
function getDropHandler(elem, supportsDragAndDropUpload) {
  return async (e) => {
    eventPreventDefault(e)
    changeElementStyle(elem, 'leave')

    if(supportsDragAndDropUpload) {
      const fileHandles = [];

      for (const item of e.dataTransfer.items) {
        if (item.kind === 'file' && item.type !== '') {  // Check if the dropped item is a file and not a directory
          const fileHandle = supportsDragAndDropUpload.value
              ? item.getAsFileSystemHandle()
              : item.webkitGetAsEntry();

          if (/\.(mp4|mov|wmv|avi)$/i.test(fileHandle.name)) {
            fileHandles.push(fileHandle);
          }else{
            toast.warning(languageStore.get('checkFileExtension'))
          }
        }
      }

      if (fileHandles.length > 0) {
        handleUploads(fileHandles, onFileDrop);
      }
    }
  }
}
const preview = async (videoId)=>{
 /* const response = await axios.get("/preview/" + videoId)
      .then(s=> {
        console.log(s);
      })*/
  window.open(`${baseUrl}/preview/${videoId}`);
  // const videoBlob = new Blob([response.data], {type: 'video/mp4'})
  // await window.open(URL.createObjectURL(videoBlob), '_blank');

}

async function handleUploads(fileHandlesPromises, uploadFunction) {
  const uploadPromises = []
  for await (const handle of fileHandlesPromises) {
    uploadPromises.push(uploadFunction(handle))
  }
}
function eventPreventDefault(e) {
  e.preventDefault()
}
const onFileDrop = file => {
  selectedItem.value = {
    videoId: '',
    videoTitle: '',
    meetingId: '',
    file,
    name: file.name,
    videoDescription: '',
    openYn: false,
    snsType: []
  };
  openModal("dragAndDrop")
};

const initialPosition = ref(0);
const initialWidth = ref(0);

const areaResizing = (e) => {
  if (!isResizing.value) {
    initialPosition.value = e.clientX;
    initialWidth.value = document.querySelector('#resize').getBoundingClientRect().width;
    return;
  }

  const resizeArea = document.querySelector('#resize');
  const resizeBar = document.querySelector('#resizeBar');
  const movementX = initialPosition.value - e.clientX;
  const newWidth = initialWidth.value - movementX;
  const newWidthInRem = newWidth / 16;

  if (newWidthInRem > 10 && newWidthInRem < 30) {
    resizeArea.style.minWidth = `${newWidthInRem}rem`;
    resizeBar.style.left = `${newWidthInRem}rem`
  }

};

const mouseUpHandler = () => set_isResizing(false);

onMounted(()=>{
  let fileUploadArea = document.querySelector('#file-upload-container')
  setupElement(fileUploadArea, supportsDragAndDropUpload.value)
  getVideos();
  childrenFolders.value = folderStore.getChildrenFolder(currentFolder.value);
  emits('set_title', title.value)
  watch(title, (v) => emits('set_title', v))

  window.addEventListener("click", closeModal);
  window.addEventListener('mouseup', mouseUpHandler);
  window.addEventListener('mousemove', areaResizing);
})
onBeforeUnmount(() => {
  window.removeEventListener("click", closeModal);
  window.removeEventListener('mousemove', areaResizing);
  window.removeEventListener('mouseup', mouseUpHandler);
});
</script>
<template>
  <v-snackbar v-model="toast.show.value" :color="toast.color.value" :timeout="toast.timeout.value" location="top">
    {{ toast.message.value }}
    <template v-slot:actions>
      <v-btn variant="text" @click="toast.close()">{{ languageStore.get('close') }}</v-btn>
    </template>
  </v-snackbar>
  <div class="container"
       id="container"
       @mousemove="areaResizing"
  >
    <div class="resizeBar" id="resizeBar"
         @mousedown="set_isResizing(true)"
    >
      <v-icon>mdi-drag-vertical-variant</v-icon>
    </div>

    <div class="leftSideArea" @contextmenu.prevent="rightSideClickEvent">
      <aside

          class="SNB"
          id="resize"
      >

        <article class="SNB_manager">

        </article>
        <article class="SNB_search">
          <div class="input_group_wrap">
            <v-text-field
                class="search_input"
                v-model="searchFolder"
                append-inner-icon="mdi-magnify"
                :label="languageStore.get('folderName')"
                variant="outlined"
                density="compact"
                hide-details
                @contextmenu.prevent.stop
            ></v-text-field>
          </div>
        </article>
        <article class="SNB_List" id="jstree">
          <getTree
              class="tree_component"
              @set_currentFolder="set_currentFolder"
              :currentFolder ="currentFolder"
              :searchFolder="searchFolder"
              :isChangeFolder="isChangeFolder"
              @rightSideClickEvent = "rightSideClickEvent"
              @set_isChangeFolder="set_isChangeFolder"
              @contextmenu.prevent.stop
          ></getTree>
        </article>
      </aside>
    </div>
    <div class="rightSideArea">
      <div class="mainArea">
        <div class="mainContentArea" >
          <div class="contentTopArea">
            <div class="contentNavArea">
              <template v-if="upperFolder">
                <v-icon @click="folderIn(upperFolder.upperFolderId)" v-if="upperFolder.upperFolderId">mdi-arrow-up-box</v-icon>
              </template>

              <template>
                <v-icon color="#c7c7c7">mdi-arrow-up-box</v-icon>
              </template>
              <template v-for="(nav,i) in folderStore.getNavFolder(currentFolder)" :key="nav.folderId">
                <div v-if="i !== 0 ">
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </div>
                <div class="navText" v-if="currentFolder == nav.folderId" @click.stop="rightSideClickEvent" >
                  {{nav.folderName}}
                    <v-icon color="black">mdi-menu-down</v-icon>
                </div>
                <div class="beforeNavText" v-else @click="set_currentFolder(nav.folderId)">
                  {{nav.folderName}}
                </div>
              </template>
            </div>
            <div class="contentHelpArea">
              <div class="d-flex align-items-center">
                <total-count :total-count="totalCount"></total-count>
                <div class="searchArea">
                  <v-text-field
                      class="search_input"
                      v-model="searchValue"
                      @keyup.enter="fn_search"
                      hide-details
                      variant="outlined"
                      density="compact"
                      :label="languageStore.get('title')"
                      append-icon="mdi-magnify"
                      @click:append="fn_search"
                  ></v-text-field>
                  <div class="searchIcon">
                    <v-chip
                        v-if="isVideoSearching"
                        closable
                        @click:close="searchCancel()"
                        density="comfortable"
                        size="large"
                    >
                      {{searchVideo}}
                    </v-chip>
                  </div>
                </div>
              </div>
              <admin-video-button
                  @videoDownload = "videoDownload"
                  @deleteItems="deleteSelectedItems"
                  @openModal="openModal"
                  @set_isFolderModal="set_isFolderModal"
                  @set_isMoveModal="set_isMoveModal"
                  @showTransferModal="showTransferModal"
              ></admin-video-button>
            </div>
          </div>

          <div class="contentData" @contextmenu.prevent="rightSideClickEvent" id="file-upload-container">
            <div class="contentHead">
              <div>{{languageStore.get('title')}}</div>
              <div>{{languageStore.get('size')}}</div>
              <div>{{languageStore.get('time')}}</div>
              <div>{{languageStore.get('registrationDate')}}</div>
              <div>{{languageStore.get('transferStatus')}}</div>
              <div>{{languageStore.get('snsRegistrationStatus')}}</div>
            </div>
            <div class="contentBody" id="contentBody">
              <template v-if="childrenFolders != []">
                <div class="folderList"
                     :class="{ selectedFolderList: selectedFolder == f.folderId }"
                     v-for="f in childrenFolders"
                     :key="f.folderId"
                     @dblclick="folderIn(f.folderId)"
                     @click="set_selectedFolder(f.folderId)"
                     @contextmenu.prevent.stop="rightSideClickEvent($event,'folder', f.folderId)">
                  <div>
                    <v-icon
                        color="#FFCE46"
                        class="folderLogo"
                    >mdi-folder</v-icon>
                    &nbsp;&nbsp;
                    {{f.folderName}}
                  </div>
                </div>
              </template>
              <template v-if="videoLists.length > 0">
                <template v-for="(video, i) in computedList" :key="i">
                  <div class="videoList"
                       :class="{ selectedVideoList: checkedItems.includes(video.id) }"
                       :id="video.id"
                       @dblclick="openDetailModal(video)"
                       @click="toggleItemSelection(video.id)"
                       @contextmenu.prevent.stop="rightSideClickEvent($event,'file', video.id)">
                    <div :title="video.videoTitle">

<!--                      <v-icon @click="preview(video.id)">mdi-movie-play-outline</v-icon>-->
                      <div class="videoTitle" >{{video.videoTitle}}</div>
                    </div>
                    <div class="centerArray" >{{comStore.formatVideoSize(video.videoSize)}}</div>
                    <div class="centerArray" >{{comStore.formatVideoTime(video.videoTime)}}</div>
                    <div class="centerArray" >{{ formatDate(video.regDt, 'YYYY-MM-DD') }}</div>

                    <div class="centerArray">
                      <template v-if="video.transferStatus === 'SUCCESS'">
                        <v-icon color="green" size="20">mdi-check-circle</v-icon>
                      </template>
                      <template v-else-if="video.transferStatus === 'FAILED'">
                        <v-icon color="red" size="20" style="cursor: pointer" @click.stop="openDetailModal(video)">mdi-close-circle</v-icon>
                      </template>
                      <template v-else>
                        <span>-</span>
                      </template>
                    </div>
                    <div class="centerArray">
                      <template v-if="video.snsVideo.length >0">
                        <template v-for="snsVideo in video.snsVideo" :key="snsVideo">
                          <div v-if="snsVideo.snsType === 'youtube'" class="centerArray">
                            <img src="@/assets/YouTube.png" class="youtube logos" @click="openYoutubeVideoLink(snsVideo.snsVideoId)">
                          </div>
                          <div v-if="snsVideo.snsType === 'meta'" class="centerArray">
                            <img src="@/assets/Facebook.png" class="meta logos">
                          </div>
                          <div v-if="snsVideo.snsType === 'twitter'" class="centerArray">
                            <img src="@/assets/Twitter.png" class="twitter logos">
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <div>-</div>
                      </template>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="videoLists.length === 0 && (!childrenFolders || childrenFolders.length === 0)">
                <div class="noData">
                  <v-icon size="48" color="#B0BEC5" class="mb-2">mdi-video-off-outline</v-icon>
                  <p>{{languageStore.get('noVideo')}}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 상세화면을 오른쪽에서 보여주게하려고 test 2024.10.17 beom-->
    <div class="test">

    </div>
  </div>

  <admin-video-modal
      v-if="showInsertModal"
      @close="showInsertModal = false"
      :modal-data="selectedService"
      :selectedItem="selectedItem"
      :currentFolder="currentFolder"
      @insertModalClose="insertModalClose"
  ></admin-video-modal>
  <detail-video
      :video="selectedItem"
      :isVideoDetail="isVideoDetail"
      @set_isVideoDetail="set_isVideoDetail"
  ></detail-video>
  <subMenuModal
      v-if="isSubModal"
      :subModalType="subModalType"
      :subModalValue="subModalValue"
      :modalX="modalX"
      :modalY="modalY"
      @deleteItems="deleteSelectedItems"
      @closeModal="closeModal"
      @openModal="openModal"
      @videoDownload="videoDownload"
      @set_isFolderModal="set_isFolderModal"
      @set_isNameChangeModal="set_isNameChangeModal"
      @set_isMoveModal="set_isMoveModal"
      @set_isTransferModal="set_isTransferModal"
  ></subMenuModal>
  <folderModal
      :is-folder-modal="isFolderModal"
      @set_isFolderModal="set_isFolderModal"
      @saveFolder ="saveFolder"
  >
  </folderModal>
  <name-change-modal
      :subModalType="subModalType"
      :subModalValue="subModalValue"
      :is-name-change-modal="isNameChangeModal"
      @editName="editName"
      @set_isNameChangeModal="set_isNameChangeModal"
  ></name-change-modal>
  <move-modal
      :currentFolder="currentFolder"
      :is-move-modal="isMoveModal"
      @set_isMoveModal="set_isMoveModal"
      @moveItems="moveItems"
  ></move-modal>
  <transferModal
      :isTransferModal="isTransferModal"
      @set_is-transfer-modal="set_isTransferModal"
      @transferVideos="transferVideos"
  ></transferModal>
  <delete-video-modal
      :isDeleteModal="isDeleteModal"
      :selectedVideos="selectedVideosForDelete"
      @close="isDeleteModal = false"
      @confirmDelete="confirmVideoDelete"
  ></delete-video-modal>
</template>
<style scoped>

@import '../../node_modules/jstree/dist/themes/default/style.min.css';
.contentHead{
  display: grid;
  grid-template-columns: 26vw 6vw 8vw 10vw 8vw 12vw;
  background: #052C65;
  color: white;
  height: 4.5vh;
  align-items: center;
  font-weight: bold;
  padding-left: 10px;
}
.contentHead div{
  display: flex;
  align-items: center;
  justify-content: center;
}
.folderList{
  display: flex;
  align-items: center;
  min-height: 5.5vh;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  padding-left: 10px;
  user-select: none;
}
.selectedFolderList{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #C7C7C7;
  background-color: #E0F0FF;
  padding-left: 10px;
}
.videoList{
  display: grid;
  grid-template-columns: 26vw 6vw 8vw 10vw 8vw 11vw;
  align-items: center;
  min-height: 5.5vh;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  padding-left: 10px;
  user-select: none;
}
.selectedVideoList {
  display: grid;
  grid-template-columns: 26vw 6vw 8vw 10vw 8vw 11vw;
  align-items: center;
  border-bottom: 1px solid #C7C7C7;
  background-color: #E0F0FF;
  padding-left: 10px;
}
.videoList:hover{
  background: #DADFEA;
}
.videoList div{
  display: flex;
  align-items: center;
}
.mainContentArea{
  background: white;
  width: 70vw;
  height: 80vh;
  border-radius: 4px;
}
.mainArea{
  width: 100%;
  background: #EEF1F5;
  display: flex;
  flex-direction: column;
  align-items: center;
  border:none;
}
.searchArea {
  display: flex;
  margin-left: 10px;
}
.contentHelpArea{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contentTopArea{
  height: 10vh;
  display: flex;
  flex-direction: column;
  margin:10px;
  justify-content: space-between;
}
.container{
  display:flex;
  justify-content: center;
  align-items: center;
}

.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  color: #90A4AE;
  font-size: 14px;
}
.logos{
  width: 24px;
  height: 24px;
}
.description {
  width:20vw;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  justify-content: flex-start;
}
.contentBody{
  height: 63vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-color: #accdf2 transparent;
}
.contentBody::-webkit-scrollbar{
  width: 12px;
}
.contentBody::-webkit-scrollbar-thumb{
  background-color: #accdf2;
  border-radius: 10px;
}
.centerArray {
  display: flex;
  justify-content: center;
}
.beforeNavText{
  color: gray;
  cursor:pointer;
  padding: 0 10px 0 10px ;
}
.beforeNavText:hover{
  background-color: #052C65;
  color:white;
  border-radius: 10px;
}
.navText{
  padding: 0 10px 0 10px ;
  font-weight:bold;
  cursor:pointer;
}
.navText:hover{
  border-radius: 10px;
  border: 1px solid #C7C7C7;
}
.contentNavArea{
  display: flex;
}
.SNB_manager{
  display: flex;
}
.resizeBar{
  height: 5rem;
  position: relative;
  top: 0rem;
  left: 15rem;
  cursor: e-resize;
  display: flex;
  align-items: center;
}
.searchIcon{
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.videoTitle{
  margin-left: 14px;
}
.test{
  width: 10vw;
  height: 80vh;
  background-color: white;
}
.search_input{
  min-width: 200px;
  max-width: 300px;
}
</style>